export const MOBILE_BREAKPOINT = 840;
/** Lato corto sotto questa soglia = telefono / cover Fold, non tablet. */
export const NARROW_EDGE_PX = 520;

const TOUCH_TABLET_MQ =
  '(min-width: 840px) and (max-width: 1440px) and ((pointer: coarse) or (hover: none))';

const FOLDABLE_UA = /SM-F\d|SM-W\d|Fold|Galaxy Z/i;

export const isIpadOs = (nav = typeof navigator === 'undefined' ? null : navigator) => {
  if (!nav) return false;
  const ua = nav.userAgent || '';
  return (
    /iPad/i.test(ua) ||
    (nav.platform === 'MacIntel' && (nav.maxTouchPoints || 0) > 1)
  );
};

export const isFromAppClient = (
  win = typeof window === 'undefined' ? null : window,
) => {
  if (!win) return false;
  if (win.ReactNativeWebView) return true;
  try {
    return Boolean(win.localStorage?.getItem('fromApp'));
  } catch {
    return false;
  }
};

const mediaMatches = (query, win) => {
  try {
    return Boolean(win.matchMedia?.(query)?.matches);
  } catch {
    return false;
  }
};

/** Samsung Z Fold / Flip e simili (UA). */
export const isFoldableUa = (nav = typeof navigator === 'undefined' ? null : navigator) => {
  if (!nav) return false;
  return FOLDABLE_UA.test(nav.userAgent || '');
};

/**
 * Viewport “stretto” (cover Fold, telefono, app a metà schermo).
 * Usa il lato corto così landscape stretto resta “narrow”.
 */
export const isNarrowViewport = ({
  width,
  height,
  win = typeof window === 'undefined' ? null : window,
} = {}) => {
  if (!win && !Number.isFinite(width) && !Number.isFinite(height)) return false;
  const w = Number.isFinite(width) ? width : win?.innerWidth || 0;
  const h = Number.isFinite(height) ? height : win?.innerHeight || 0;
  const shortEdge = Math.min(w, h);
  return shortEdge > 0 && shortEdge < NARROW_EDGE_PX;
};

/**
 * Layout denso: foldable UA, cover / metà schermo, o segmenti viewport multipli.
 * Su questi device il font-lock con `width: 100%/zoom` taglia i CTA.
 */
export const isDensePhoneLayout = ({
  width,
  height,
  win = typeof window === 'undefined' ? null : window,
  nav = typeof navigator === 'undefined' ? null : navigator,
} = {}) => {
  if (isFoldableUa(nav)) return true;
  if (isNarrowViewport({ width, height, win })) return true;
  if (win && mediaMatches('(horizontal-viewport-segments: 2), (vertical-viewport-segments: 2)', win)) {
    return true;
  }
  return false;
};

/**
 * Tablet (non telefono): iPad in modalità desktop, Android/iPad WebView,
 * e qualsiasi schermo ≥840px con input touch. Senza questo, l'app sul tablet
 * usa il layout desktop e il calendario non pan-na.
 *
 * I foldable aperti restano tablet per il layout UI, ma il font-lock li tratta a parte.
 */
export const readIsTablet = ({
  width,
  win = typeof window === 'undefined' ? null : window,
  nav = typeof navigator === 'undefined' ? null : navigator,
} = {}) => {
  if (!win) return false;
  const viewportWidth = Number.isFinite(width) ? width : win.innerWidth || 0;
  if (viewportWidth < MOBILE_BREAKPOINT) return false;
  // Cover / flex mode: lato corto da telefono anche se width ≥ 840 in landscape.
  if (isNarrowViewport({ width: viewportWidth, win })) return false;
  if (isIpadOs(nav)) return true;
  if (mediaMatches(TOUCH_TABLET_MQ, win)) return true;
  // App nativa: il WebView a volte mente su pointer/hover.
  if (isFromAppClient(win)) return true;
  return false;
};

export const TOUCH_TABLET_MEDIA_QUERY = TOUCH_TABLET_MQ;
